module.exports = __webpack_public_path__ + "static/iheartsa-b84a6f6ab5b10efbf29731966f6316d5.jpg";